import { Loader2 } from 'lucide-react';
import { Card } from '../ui/card';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
  compact?: boolean;
  className?: string;
}

export function LoadingState({
  message = 'Loading...',
  fullScreen = false,
  compact = false,
  className = ''
}: LoadingStateProps) {
  const content = (
    <div className={`flex flex-col items-center justify-center ${compact ? 'py-8' : 'py-12'}`}>
      <Loader2 className={`${compact ? 'h-8 w-8' : 'h-12 w-12'} animate-spin text-primary mb-4`} />
      <p className="text-muted-foreground">{message}</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#D4F0F8]">
        {content}
      </div>
    );
  }

  if (compact) {
    return <div className={className}>{content}</div>;
  }

  return (
    <Card className={className}>
      {content}
    </Card>
  );
}
